import {EventPropName} from '@mintdata/mint-kit/api/events/EventType';
import {IComponentLogic} from '@mintdata/mint-kit/api/events/logic/IComponentLogic';
import {BindPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {ObjectValidationResult, ValidationResultBuilder} from '@mintdata/mint-kit/api/properties/ValidationResult';

export class BaseLogic<P> implements IComponentLogic<P>
{
    public onEvent(type:EventPropName, e:any, props:P):any
    {
        return (typeof this[type] === 'function') && this[type](e, props) || null;
    }

    public validate(bindPath:BindPath, props:P):ObjectValidationResult
    {
        return new ValidationResultBuilder().valid(bindPath).result();
    }
}
